import React from 'react';

const BatteryEmpty: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M4 7V17H18V7H4ZM3 5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5V5ZM21 9H23V15H21V9Z" />
  </>
);

export default BatteryEmpty;
